// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/mall.css
// module id = 552
// module chunks = 2